import { useEffect, useState, useCallback } from "react";
import api from "@/lib/api";
import { inputCls, formatDate } from "@/lib/constants";
import { History, Search } from "lucide-react";

const ACTION_STYLE = {
  create: "bg-emerald-100 text-emerald-700 border-emerald-300",
  update: "bg-blue-50 text-blue-700 border-blue-200",
  delete: "bg-rose-50 text-rose-700 border-rose-200",
};

export default function Audit() {
  const [rows, setRows] = useState([]);
  const [search, setSearch] = useState("");

  const load = useCallback(() => {
    const q = search ? `?search=${encodeURIComponent(search)}` : "";
    api.get(`/audit-logs${q}`).then((r) => setRows(r.data)).catch(() => {});
  }, [search]);
  useEffect(() => { const t = setTimeout(load, 300); return () => clearTimeout(t); }, [load]);

  return (
    <div className="space-y-6" data-testid="audit-page">
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
        <div>
          <h1 className="text-2xl sm:text-3xl font-extrabold text-slate-900 font-heading tracking-tight flex items-center gap-2"><History size={26} className="text-emerald-600" /> Audit Log</h1>
          <p className="text-sm text-slate-500 mt-1">Who created, edited or deleted what — across every section.</p>
        </div>
        <div className="relative">
          <Search size={15} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
          <input data-testid="audit-search" value={search} onChange={(e) => setSearch(e.target.value)} className={`${inputCls} pl-9 sm:w-72`} placeholder="Search user or action…" />
        </div>
      </div>

      <div className="rounded-xl border border-slate-200 bg-white shadow-sm overflow-hidden overflow-x-auto">
        <table className="w-full min-w-[720px]">
          <thead><tr className="bg-slate-50 text-xs font-semibold uppercase tracking-wider text-slate-500 border-b border-slate-200">
            <th className="text-left px-4 py-3">When</th><th className="text-left px-4 py-3">User</th><th className="text-left px-4 py-3">Section</th><th className="text-left px-4 py-3">Action</th><th className="text-left px-4 py-3">Details</th>
          </tr></thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.id} data-testid={`audit-row-${r.id}`} className="border-b border-slate-100 text-sm text-slate-700">
                <td className="px-4 py-3 text-xs text-slate-500 whitespace-nowrap">{formatDate(r.at)}</td>
                <td className="px-4 py-3"><div className="font-medium text-slate-900">{r.user_name || "—"}</div><div className="text-xs text-slate-400">{r.role}</div></td>
                <td className="px-4 py-3"><span className="text-xs bg-slate-100 text-slate-600 rounded-full px-2 py-0.5">{r.section}</span></td>
                <td className="px-4 py-3"><span className={`px-2 py-0.5 rounded-full text-xs font-medium border capitalize ${ACTION_STYLE[r.action] || "bg-slate-100 text-slate-600 border-slate-200"}`}>{r.action}</span></td>
                <td className="px-4 py-3">{r.summary}</td>
              </tr>
            ))}
            {rows.length === 0 && <tr><td colSpan={5} className="px-4 py-12 text-center text-slate-400 text-sm">No activity recorded yet.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
